var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 16.6667C9.5396 16.6667 9.1665 16.2936 9.1665 15.8334L9.1665 4.16671C9.1665 3.70647 9.5396 3.33338 9.99984 3.33338C10.4601 3.33338 10.8332 3.70647 10.8332 4.16671L10.8332 15.8334C10.8332 16.2936 10.4601 16.6667 9.99984 16.6667Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5891 9.75596C15.2637 10.0814 14.736 10.0814 14.4106 9.75596L9.99984 5.34522L5.58909 9.75596C5.26366 10.0814 4.73602 10.0814 4.41058 9.75596C4.08514 9.43053 4.08514 8.90289 4.41058 8.57745L9.41058 3.57745C9.73602 3.25201 10.2637 3.25201 10.5891 3.57745L15.5891 8.57745C15.9145 8.90289 15.9145 9.43053 15.5891 9.75596Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.2e689ca56daf6c9d24de055e78a2e43e.svg";
export { ForwardRef as ReactComponent };